export * from '../pages/_document'
export { default } from '../pages/_document'
